<template>
  <v-container class="fill-height" style="max-width: 700px;">
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card class="pa-6" outlined>
          <v-card-title class="text-h4 font-weight-bold justify-center mb-4">
            <v-icon large class="mr-3" color="primary">mdi-account-group</v-icon>
            Create Your Own Page
          </v-card-title>

          <v-card-text class="text-body-1" style="line-height: 1.8;">
            <p>
              To create your own community page, reach out to me on X
              <a
                href="https://x.com/slink_dev"
                target="_blank"
                class="contact-link"
              >@slink_dev</a>
              or on Discord
              <span class="discord-tag">@slink58 (slink#8309)</span>,
              and I can help you get set up.
            </p>

            <p class="mt-4">
              The ability to create your own page directly on the site is in the works,
              but it will be quite some time before that is released.
            </p>

            <p class="mt-4">
              If you're looking to get started now, I would recommend reaching out and not waiting for that.
            </p>
          </v-card-text>

          <v-card-actions class="justify-center mt-4">
            <v-btn
              outlined
              href="https://x.com/slink_dev"
              target="_blank"
            >
              <span class="font-weight-bold mr-2" style="font-size: 18px;">𝕏</span>
              Contact on X
            </v-btn>
            <v-btn
              color="#5865F2"
              outlined
              href="https://discord.com/users/slink58"
              target="_blank"
            >
              <v-icon left class="discord-icon-colored">$vuetify.icons.customdiscord</v-icon>
              Contact on Discord
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CreateCommunity'
}
</script>

<style scoped>
.contact-link {
  color: #E7E9EA;
  text-decoration: none;
  font-weight: 500;
}

.contact-link:hover {
  text-decoration: underline;
}

.discord-tag {
  color: #5865F2;
  font-weight: 500;
}
</style>

<style scoped>
.discord-icon-colored {
  filter: brightness(0) saturate(100%) invert(36%) sepia(71%) saturate(2034%) hue-rotate(222deg) brightness(99%) contrast(92%);
}
</style>
